module.exports = __webpack_public_path__ + "static/shape-explore-480af7094d528894cebe525ac6562d89.png";